import { navigate } from 'gatsby';

enum PageKind {
  HOME,
  ACCOUNT,
  BROWSE,
  COURSE_DETAILS,
  COURSE_REGISTRATION,
  ADMIN,
  PUBLIC_COURSE_CERTIFICATE,
  REPORT_ANALYSIS,
  SUMMARY,
}

type NavigationParams = {
  courseId?: string,
  regId?: string,
  tab?: string,
  reportId?: string
}

/**
 *
 *
 * @param {*} pageKind
 * @param {*} params
 * @return {*} path to navigate
 */
const getPathToNavigate: (pageKind: PageKind, params?: NavigationParams) =>
 string = (pageKind, params = {}) => {
   let path = '';
   const learnerBase = '/learner/';
   const adminBase = '/admin/';
   switch (pageKind) {
     case PageKind.HOME:
       path = learnerBase;
       break;
     case PageKind.ADMIN:
       path = adminBase;
       break;
     case PageKind.ACCOUNT:
       path = `${learnerBase}account/`;
       break;
     case PageKind.BROWSE:
       path = `${learnerBase}browse/`;
       break;
     case PageKind.REPORT_ANALYSIS:
       path = `${learnerBase}analysis/${params.reportId}/`;
       break;
     case PageKind.COURSE_DETAILS:
       if (params.courseId) {
         path = `${learnerBase}course-details/${params.courseId}`;
       } else {
         path = `${learnerBase}browse/`;
       }
       break;
     case PageKind.COURSE_REGISTRATION:
       if (params.regId && params.tab) {
         path = `${learnerBase}course-registration/${params.regId}/${params.tab}/`;
       } else if (params.regId) {
         path = `${learnerBase}course-registration/${params.regId}/content/`;
       } else {
         path = learnerBase;
       }
       break;
     default:
       path = learnerBase;
   }
   return path;
 };

/**
 *
 * navigates to the route
 * @param {*} pageKind
 */
const navigateTo: (pageKind: PageKind, params?: NavigationParams) =>
void = (pageKind, params = {}) => {
  const path = getPathToNavigate(pageKind, params);
  navigate(path);
};

export {
  PageKind,
  navigateTo,
  getPathToNavigate,
};
